import React, { useState, useEffect } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, } from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { setRequireCloseModal } from '../../../../slices/warehouse/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { addNewWarehouse, updateWarehouse } from '../../../../slices/warehouse/thunk';
import { getCompanyList, getEstablishmentList, getEstablishmentTypeList, getFeedingBargesList, getFuelTypeList } from '../../../../helpers/establishment/backend_helper';
import OSelect from '../../../../Components/OElements/OSelect';
import { getUnitMeasurement } from '../../../../slices/thunks';
import { getUnitMeasurementList } from '../../../../helpers/residue/backend_helper';
import { getWarehouseType, getWarehouseTypeList } from '../../../../helpers/warehouse/backend_helper';
import OInput from '../../../../Components/OElements/OInput';

const WarehouseForm = ({ dataWarehouse, isEdit, handleToggleModal, isOpen, activeTab, toggleTab, }) => {
	const dispatch = useDispatch();

	const [selectedEstablishmentType, setSelectedEstablishmentType] = useState(null);
	const [selectedType, setSelectedType] = useState(null);
	const [showFeedingBarges, setShowFeedingBarges] = useState(false);
	const [showEstablishment, setShowEstablishment] = useState(false);


	const selectorWarehouse = createSelector(
		state => state.Warehouses,
		result => ({
			isAdding: result.isAdding,
			isAdded: result.isAdded,
			isUpdating: result.isUpdating,
			isUpdated: result.isUpdated,
			isLoadingList: result.isLoadingList,
			requireCloseModal: result.requireCloseModal,
		})
	);
	const { isAdding, isAdded, isUpdating, isUpdated, isLoadingList, requireCloseModal, } = useSelector(selectorWarehouse);
	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			name: (dataWarehouse && dataWarehouse.name) || '',
			code_sap: (dataWarehouse && dataWarehouse.code_sap) || '',
			description: (dataWarehouse && dataWarehouse.description) || '',
			establishment_id: dataWarehouse?.establishment_id || null,
			warehouse_type_id: dataWarehouse?.warehouse_type_id || null,
			company_id: dataWarehouse?.company_id || null,
			respel: dataWarehouse?.respel ?? false,
		},
		validationSchema: Yup.object({
			name: Yup.string().nullable(),
			code_sap: Yup.string().nullable(),
			description: Yup.string().nullable(),
			company_id: Yup.string().required('Campo requerido'),
			establishment_id: Yup.lazy(() =>
				selectedType && selectedType.code == 'FSC'
					? Yup.string().required('Campo requerido')
					: Yup.string().nullable()
			),
			warehouse_type_id: Yup.string().required('Campo requerido'),
			respel: Yup.boolean().nullable()


		}),
		onSubmit: values => {
			const warehouse = { ...values };


			if (isEdit) {
				warehouse._id = dataWarehouse._id;
				dispatch(updateWarehouse(warehouse));
			} else {
				dispatch(addNewWarehouse(warehouse));
			}

		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);


	const handleEstablishmentTypeSelect = (optionSelected) => {
		setSelectedEstablishmentType(optionSelected);
		if (optionSelected?.barges_needed) {
			setShowFeedingBarges(true);
			setShowEstablishment(false);
		} else {
			setShowFeedingBarges(false);
			setShowEstablishment(true);
		}
	};

	const handleTypeSelect = (optionSelected) => {
		setSelectedType(optionSelected);
	};
 

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<Row className='g-3'>
					<Col lg={3}>
						<OInput
							name='name'
							label='Celular'
							type='Nombre'
							validation={validation}
							disabled={true}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
					<Col lg={3}>
						<OInput
							name='code_sap'
							label='Código SAP'
							type='Nombre'
							validation={validation}
							disabled={true}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
					<Col lg={3}>
						<OSelect
							label='Tipo de Bodega'
							id='warehouse_type_id'
							name='warehouse_type_id'
							isRequired={true}
							value={validation.values.warehouse_type_id || ''}
							onSelect={handleTypeSelect}
							onChange={validation.handleChange}
							requestApi={() => getWarehouseTypeList()}
							validation={validation}
						/>
					</Col>

					<Col lg={3}>
						<OSelect
							label='Empresa'
							id='company_id'
							name='company_id'
							isRequired={true}
							value={validation.values.company_id || ''}
							onChange={validation.handleChange}
							requestApi={() => getCompanyList()}
							validation={validation}
						/>
					</Col>

					<Col lg={3}>
						<OSelect
							key={'establishment_' + validation.values.company_id}
							label='Establecimiento Relacionado'
							id='establishment_id'
							name='establishment_id'
							value={validation.values.establishment_id || ''}
							onChange={validation.handleChange}
							requestApi={() => getEstablishmentList({ company_id: validation.values.company_id })}
							validation={validation}
						/>
					</Col>
					<Col lg={3}>
						<OSelect
							label='Residuos Peligrosos (RESPEL)'
							id='respel'
							name='respel'
							value={validation.values.respel}
							onChange={(selectedOption) => validation.setFieldValue('respel', !!selectedOption.value)} // 👈 Se asegura que sea booleano
							itemsSelect={[{ label: 'Sí', value: true }, { label: 'No', value: false }]}
							validation={validation}
						/>
					</Col>
					<Col lg={6}>
						<Label for='description' className='form-label'>
							Descripción
						</Label>
						<Input
							name='description'
							id='description'
							className='form-control'
							placeholder='Ingrese una descripción'
							type='textarea'
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.description || ''}
							invalid={validation.touched.description && validation.errors.description ? true : false}
						/>
						{validation.touched.description && validation.errors.description && (
							<FormFeedback type='invalid'>
								{validation.errors.description}
							</FormFeedback>
						)}
					</Col>
				</Row>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 modal-footer-add-btn'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button type='submit' className='btn btn-label btn-primary' id='add-btn' disabled={isAdding || isUpdating}>
						{isAdding || isUpdating ? (<i className='label-icon'><Spinner size='sm' /></i>) : (<i className='ri-save-3-line label-icon'></i>)}
						{isEdit ? 'Editar' : 'Crear'} Bodega
					</button>
				</div>
			</div>
		</Form>
	);
};

export default WarehouseForm;
